import { Ico } from "../icons/icons.jsx";
import { useThemeSlice } from "./StatusBadge.jsx";

const VARIANTS = {
  entity: { height: undefined, padding: "8px 10px 8px 34px", maxWidth: 320, radiusKey: "radiusMd", bg: "card", border: "cardBdr", fontSize: 13 },
  catalog: { height: 34, padding: "0 12px 0 34px", maxWidth: 300, radiusKey: "radiusMd", bg: "card", border: "cardBdr", fontSize: 13, type: "search" },
  sidebar: { height: 32, padding: "0 10px 0 30px", maxWidth: undefined, radius: 8, bg: "card", border: "sbBdr", fontSize: 12.5, type: "search" },
  hub: { height: 38, padding: "0 12px 0 40px", maxWidth: 420, radius: 10, bg: "hover", border: "sbBdr", fontSize: 13 },
};

export function SearchField({
  value,
  onChange,
  placeholder = "Search…",
  variant = "catalog",
  ariaLabel,
  style: styleProp,
  wrapperStyle,
}) {
  const { c, accentHex: A, chrome } = useThemeSlice();
  const v = VARIANTS[variant] ?? VARIANTS.catalog;
  const radius = v.radius ?? chrome[v.radiusKey] ?? 8;

  return (
    <div style={{ position: "relative", flex: variant === "hub" ? "1 1 220px" : "1 1 220px", minWidth: variant === "hub" ? 220 : undefined, maxWidth: v.maxWidth, ...wrapperStyle }}>
      <span
        style={{
          position: "absolute",
          left: variant === "hub" ? 12 : 10,
          top: variant === "hub" ? 10 : "50%",
          transform: variant === "hub" ? undefined : "translateY(-50%)",
          color: c.sub,
          display: "flex",
          pointerEvents: "none",
        }}
      >
        {Ico.search}
      </span>
      <input
        type={v.type ?? "text"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        style={{
          width: "100%",
          height: v.height,
          padding: v.padding,
          borderRadius: radius,
          border: `1px solid ${c[v.border]}`,
          background: c[v.bg],
          color: c.text,
          fontSize: v.fontSize,
          outline: "none",
          boxSizing: "border-box",
          fontFamily: "inherit",
          ...styleProp,
        }}
        onFocus={(e) => { e.currentTarget.style.borderColor = A; }}
        onBlur={(e) => { e.currentTarget.style.borderColor = c[v.border]; }}
      />
    </div>
  );
}
